import { useCallback } from "react";
import { newProductPlanActions } from "redux/Ldb/actions/newProductPlanActions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useDeleteNewProductPlan = (): useDeleteNewProductPlanProp => {
    const dispatch = useAppDispatch();

    const { deletingNewProductPlan, deletedNewProductPlanSuccess, deletedNewProductPlanFailure } =
        useAppSelector((state) => state.newProductPlan);

    async function deleteNewProductPlan(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            // Reset any previous state
            dispatch(newProductPlanActions.resetDeleteNewProductPlan());

            // Start the Redux action
            dispatch(newProductPlanActions.deleteNewProductPlan(id));

            // Poll for state changes
            const checkState = () => {
                const currentState = dispatch((dispatch, getState) => {
                    const state = getState();
                    return {
                        isLoading: state.newProductPlan.deletingNewProductPlan,
                        success: state.newProductPlan.deletedNewProductPlanSuccess,
                        error: state.newProductPlan.deletedNewProductPlanFailure,
                    };
                });

                if (currentState.error) {
                    console.log({ currentState });
                    reject(currentState.error);
                } else if (currentState.success && !currentState.isLoading) {
                    resolve(currentState.success);
                } else if (
                    !currentState.isLoading &&
                    !currentState.success &&
                    !currentState.error
                ) {
                    reject("Request failed without error or success response");
                } else {
                    // Still loading, check again
                    setTimeout(checkState, 100);
                }
            };

            checkState();
        });
    }

    const resetDeleteNewProductPlan = useCallback(() => {
        dispatch(newProductPlanActions.resetDeleteNewProductPlan());
    }, [dispatch]);

    return [
        deleteNewProductPlan,
        {
            isSuccess: Boolean(deletedNewProductPlanSuccess),
            isError: Boolean(deletedNewProductPlanFailure),
            isLoading: deletingNewProductPlan,
            data: deletedNewProductPlanSuccess,
            error: deletedNewProductPlanFailure,
            resetDeleteNewProductPlan,
        },
    ];
};

export default useDeleteNewProductPlan;

type useDeleteNewProductPlanProp = [
    (id: string) => Promise<any>,
    {
        isSuccess: boolean;
        isError: boolean;
        isLoading: boolean;
        data: any;
        error: any;
        resetDeleteNewProductPlan: () => void;
    }
];
